// Legacy alias — the person care surface lives on the People profile
// Follow Up tab now.
import { Redirect, useLocalSearchParams } from 'expo-router';

export default function FollowUpPersonAlias() {
    const { personID } = useLocalSearchParams();
    return <Redirect href={`/people/${personID}?tab=followup`} />;
}
